export const ILLUSTRATIONS = {
  EyeRecognition: 'eye-recognition',
  CoffeeSpill: 'coffee-spill',
  ConeDog: 'cone-dog',
} as const

export type IllustrationName = (typeof ILLUSTRATIONS)[keyof typeof ILLUSTRATIONS]

export type IllustrationColors = 'mint' | 'green'

export interface IllustrationColorScheme {
  light: string
  dark: string
}

export interface IllustrationConfig {
  variants: Record<IllustrationColors, IllustrationColorScheme>
  aspectRatio: number
}

export interface IllustrationProps {
  name: IllustrationName
  alt?: string
  width: number | `${number}`
  height?: number | `${number}`
  testId?: string
}
